module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "state control"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.title),
      expression: "tmp.title"
    }],
    staticClass: "answerTitle",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.title')
    },
    domProps: {
      "value": (_vm.tmp.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "windowButtons"
  }, [_c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": _vm.$t('common.actions.delete')
    },
    on: {
      "click": function($event) {
        return _vm.remove()
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-174d9592"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/OutState.vue
// module id = 567
// module chunks = 42